import { Vector3 } from "three";
import { IMeasurement, IMeasurementHandler } from "./types";

/** Minimal viewer surface needed to read the current panel positions. */
export interface IPanelPositionReader {
  getPanelPosition(id: number): Vector3 | undefined;
}

/**
 * Builds the payload for the measurement list upload
 * (PUT .../point-cloud/:type/measurement), which overwrites the whole array.
 *
 * Carries each measurement's current panel position (SC_QUICK-2187,
 * QU3DW-1367). Without it, saving any measurement wipes the saved panel
 * positions of all the others, because the overwritten file no longer holds
 * them — measurements dragged earlier would snap back to their default
 * position after a reload.
 */
export function toMeasurementUploadPayload(
  measurements: IMeasurementHandler[],
  viewer: IPanelPositionReader,
  updateAt: string
): IMeasurement[] {
  return measurements.map((measurement) => {
    const payload: IMeasurement = {
      id: measurement.id,
      type: measurement.type,
      _points: measurement._points,
      value: measurement.value,
      visible: measurement.getVisibility() ?? false,
      updateAt,
    };

    const position = viewer.getPanelPosition(measurement.id);
    if (position) {
      payload.panelPosition = {
        x: position.x,
        y: position.y,
        z: position.z,
      };
    } else if (measurement.panelPosition) {
      // Viewer could not report a position (e.g. the measurement is not in the
      // scene right now) — keep whatever was loaded from the server so the
      // save does not drop it.
      payload.panelPosition = measurement.panelPosition;
    }

    return payload;
  });
}
